import api from "../api/axios";
import ENDPOINTS from "../api/endpoints";

export const getMyProfile = async () => {
  const response = await api.get(ENDPOINTS.USERS.ME);
  return response.data;
};

export const getProfile = getMyProfile;
export const getMe = getMyProfile;

export const getAllUsers = async () => {
  const response = await api.get(ENDPOINTS.USERS.ALL);
  return response.data;
};

export const getUsers = getAllUsers;

export const getUserById = async (id) => {
  const response = await api.get(ENDPOINTS.USERS.BY_ID(id));
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await api.delete(ENDPOINTS.USERS.DELETE(id));
  return response.data;
};

export const removeUser = deleteUser;

export const getUsersByRole = async (role) => {
  const response = await api.get(ENDPOINTS.USERS.BY_ROLE(role));
  return response.data;
};

export const getUserBookings = async (id) => {
  const response = await api.get(ENDPOINTS.USERS.BOOKINGS(id));
  return response.data;
};

const userService = {
  getMyProfile,
  getProfile,
  getMe,
  getAllUsers,
  getUsers,
  getUserById,
  deleteUser,
  removeUser,
  getUsersByRole,
  getUserBookings,
};

export default userService;